import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
    FullPageMessage,
    FullPageMessageGoToMyChartersButton,
    FullPageMessageGoToRootButton
} from 'acscp/components/common/fullPageMessage';
import backgroundStyle from 'acscp/styles/containerBackgrounds.module.scss';

const ThankYou: React.SFC<{ isBookingOwner: boolean }> = ({ isBookingOwner }) => {
    return (
        <FullPageMessage
            title={
                <FormattedMessage id={'components.quotes.quoteAccept.thankYou'} defaultMessage={'Thank You'}/>
            }
            message={
                isBookingOwner ?
                    <FormattedMessage
                        id={'components.quotes.quoteAccept.thankYouMessage'}
                        defaultMessage={'Your Account Manager is now confirming final availability ' +
                        'of the aircraft and will contact you shortly'}
                    /> :
                    <FormattedMessage
                        id={'components.quotes.quoteAccept.sharedThankYouMessage'}
                        defaultMessage={'The Account Manager is now confirming final availability ' +
                        'of the aircraft and will contact the main account holder shortly'}
                    />
            }
            buttons={FullPageMessageGoToMyChartersButton}
            containerClassName={backgroundStyle.CloudBackground}
        />
    );
};

export { ThankYou };
